import styled from '@emotion/styled'
import { DropDown } from 'app/components/Common/Animation/DropDown'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { Media } from 'app/theme/media'
import React, { createContext, memo } from 'react'

import { Bottom } from './Bottom'
import { Contacts } from './Contacts'
import { Credits } from './Credits'
import { Props as PolicyMenuItemProps } from './PolicyMenuItem'
import { Social } from './Social'

export interface Props {
  address?: string
  cin?: string
  email?: string
  facebookURL?: string
  googleMapsURL?: string
  instagramURL?: string
  languageCode: string
  languagePrefix?: string | null
  phone?: string
  policyMenu?: { [key: string]: PolicyMenuItemProps[] }[]
  rea?: string
  vat?: string
  worksPageURL?: string
}

export const FooterContext = createContext({})

export const Footer = memo(function Footer({
  address,
  cin,
  email,
  facebookURL,
  googleMapsURL,
  instagramURL,
  languageCode,
  languagePrefix,
  phone,
  policyMenu,
  rea,
  vat,
  worksPageURL,
}: Props) {
  return (
    <FooterContext.Provider
      value={{
        address,
        cin,
        email,
        facebookURL,
        googleMapsURL,
        instagramURL,
        languageCode,
        languagePrefix,
        phone,
        policyMenu,
        rea,
        vat,
        worksPageURL,
      }}
    >
      <>
        <Container>
          <Wrapper row stretch wrap>
            <LeftSide>
              <Contacts />

              <Social />
            </LeftSide>

            <RightSide>
              <Media greaterThanOrEqual="desktopSmall">
                <DropDown>
                  <Background />
                </DropDown>
              </Media>
            </RightSide>
          </Wrapper>

          <Bottom />
        </Container>

        <Credits />
      </>
    </FooterContext.Provider>
  )
})

const Container = styled.section`
  background: ${({ theme }) => theme.colors.variants.primaryDark};
`

const Wrapper = styled(FlexBox)`
  padding: 7.5rem 8.333vw 3.75rem;

  @media (max-width: 1199px) {
    padding: 3.75rem 1.875rem;
  }
`

const LeftSide = styled.div`
  width: 50%;

  @media (max-width: 1199px) {
    width: 100%;
    text-align: center;
  }
`

const RightSide = styled.div`
  width: 50%;
  position: relative;

  > div {
    height: 100%;
  }

  @media (max-width: 1199px) {
    width: 100%;
  }
`

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: url('/footer-image.webp') no-repeat center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
`
